import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const QRCodeList = () => {
    const [qrCodes, setQRCodes] = useState([]);
    const [filteredQRCodes, setFilteredQRCodes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch('http://pbhrm.com/api/qrcodes')
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setQRCodes(data.data);
                    setFilteredQRCodes(data.data);
                } else {
                    alert('Failed to fetch QR codes');
                }
            })
            .catch(error => console.error('Error fetching QR codes:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
        const filtered = qrCodes.filter(qrCode =>
            qrCode.category.toLowerCase().includes(term.toLowerCase()) ||
            qrCode.sub_category.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredQRCodes(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditQRCode/${id}`);
    };

    const handleAdd = () => {
        navigate('/AddQRCode');
    };

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this QR code?')) {
            fetch(`http://pbhrm.com/api/qrcodes/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setQRCodes(qrCodes.filter(qrCode => qrCode.id !== id));
                        setFilteredQRCodes(filteredQRCodes.filter(qrCode => qrCode.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting QR code:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>QR Codes List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="searchTerm" className="form-label">Search</label>
                                        <input
                                            type="text"
                                            id="searchTerm"
                                            className="form-control"
                                            placeholder="Search by category or sub-category"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add QR Code</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Category</th>
                                                <th>Sub Category</th>
                                                <th>Image</th>
                                                <th>Item ID</th>
                                                <th>QR Code</th>
                                                <th>Created At</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredQRCodes.map(qrCode => (
                                                <tr key={qrCode.id}>
                                                    <td>{qrCode.id}</td>
                                                    <td>{qrCode.category || 'N/A'}</td>
                                                    <td>{qrCode.sub_category || 'N/A'}</td>
                                                    <td>
                                                        <img
                                                            src={`http://localhost:8000/${qrCode.image}`}
                                                            alt="Image"
                                                            style={{ width: '100px', height: 'auto' }}
                                                        />
                                                    </td>
                                                    <td>{qrCode.item_id}</td>
                                                    <td>
                                                        <img
                                                            src={qrCode.qr_code}
                                                            alt="QR Code"
                                                            style={{ width: '100px', height: 'auto' }}
                                                        />
                                                    </td>
                                                    <td>{new Date(qrCode.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(qrCode.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(qrCode.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default QRCodeList;
